import { Component, OnInit,ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {NgbTimepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  
import { DomSanitizer} from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core'; 
import { TreeNode } from "primeng/api";
export interface NewTreeNode extends TreeNode {
  visible?: boolean;
  children?: NewTreeNode[];
}
@Component({
  selector: 'app-documentofinal',
  templateUrl: './documentofinal.component.html',
  styleUrls: ['./documentofinal.component.scss']
})
export class DocumentofinalComponent implements OnInit {
  @ViewChild('close_est',null) close_est;  
  @ViewChild('clo_d',null) clo_d;  
  @ViewChild('clo_r',null) clo_r; 
  @ViewChild('clo_ht',null) clo_ht; 
  
  constructor(public authService: AuthService,
    public sanitizer:DomSanitizer, config: NgbTimepickerConfig,
    public router: Router) { }
    @ViewChild('clo_pernva',null) clo_pernva;
    @ViewChild('clo_pernva2',null) clo_pernva2;
    @ViewChild('clo_pernva3',null) clo_pernva3;
    @ViewChild('clo_pernva4',null) clo_pernva4;
  ngOnInit() {
    this.sufijo_cliente=localStorage.getItem("sufijo_cliente")
    this.nomCliente=localStorage.getItem("nom_cliente")

    this.ls_puestos()
   
    //this.get_org(); 
    this.get_raci();
    this.ls_ws();
    this.org=[];
  }
  org_;
  node_sel(n){
    this.org_=[];
    if(n.data==0)return;
    this.estructura.id=n.data;
    this.estructura.nombre=n.label;
    //console.log(this.org_aux)
    //console.log(n)
    for(var i = 0; i < this.org_aux.length;i++){
      if(this.org_aux[i].id_role==n.data){
        this.org_.push(this.org_aux[i])
      }      
      
    }
   
    //this.collapseAll();
    //this.raci_list=[];
    //console.log(n.data)
    /*
    for(var i=0;i<this.raci.length;i++){
      if(this.raci[i].id_org==n.data){
        console.log("es correcto")
        this.raci_list.push(this.raci[i]);
      }
    }
    
    console.log(this.raci_list)*/
    //alert(n.data)
    this.close_est.nativeElement.click();
  }
  id_cliente=0;
  ls_puestos(){  
    this.id_cliente=Number(localStorage.getItem("id_cliente"));
    
    this.loading =  true;
    var sqry;
    sqry 
    this.authService.service("/api/get_org",{id_cliente:localStorage.getItem("id_cliente")})
    .then(
      data  => { 
        this.loading =  false;       
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.org_aux=res;
        if (res.length!=0){
          var _vec = [];
          _vec.push({ 
            id: 0, 
            id_ant: -1, 
            nombre: "Estructura organizacional", 
          });    
          for(var i = 0; i < res.length;i++){
            if(res[i].organo!='A')
            _vec.push({ 
              id: res[i].id_role, 
              id_ant: res[i].idarea1, 
              nombre: res[i].role_card, 
              sufijo: res[i].sufijo, 
            });                         
          }
          this.org = _vec
          
          for(let i=0;i<this.org.length;i++){
            if(this.org[i].id==0){
              this.nodes=[{
                label: this.org[i].nombre,
                total: this.org[i].total,
                data: this.org[i].id,
                dataA: this.org[i].idarea1,
                dataC:"",
                children:this.get_nodes(this.org[i].id,"")
                }];
            }
          }

          this.options = this.nodes ;
          this.options = this.getValidTreeNodeItems(this.options);

        }
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }
  nodes;
  options;
  loading;
  getValidTreeNodeItems(treeNodes: NewTreeNode[]): NewTreeNode[] {
    const validItem = treeNodes.filter(i => i.visible !== false);

    validItem.forEach(i => {
      if (i.children) {
        i.children = this.getValidTreeNodeItems(i.children);
      }
    });
    return validItem;
  }
  get_nodes(id,c){
    //console.log(c)
    var child:any=[];
    for(var x=0;x<this.org.length;x++){
      if (this.org[x].id_ant==id){
       
        child.push({
          label: this.org[x].nombre,
          total: this.org[x].total,
          data: this.org[x].id,
          dataA: this.org[x].id_ant,  
          dataC:(c.length==0?"":c+",")+this.org[x].sufijo,
          departamento: this.org[x].departamento,        
          children:this.get_nodes(this.org[x].id,(c.length==0?"":c+",")+this.org[x].sufijo)
        });
      }
    }
    return child;
  }


  sufijo_cliente=""
  nomCliente=""
  bndc1;
  bndc2;
  bndc3;
  documento={
    n1:0,
    n2:0,
    n3:0,
    c1:"El Manual de Procesos y Procedimientos de EcoShell, es un documento técnico de sistematización que contiene la descripción detallada de la secuencia de acciones de ejecución de los procesos organizacionales, en el nivel de microprocesos o actividades, en los que intervienen una o más unidades operativas."+
    "\rLa metodología seguida para la elaboración del Manual, plantea en primer lugar determinar el Mapeo y Caracterización de cada Proceso involucrado, identificando los pasos que alimentan al proceso, documentos y/o hojas de trabajo; así como los procedimientos propios de la elaboración del manual."+
    "\rLa metodología que se utilizó, se denomina RACSI, que por sus siglas en inglés sugieren que en cada proceso debe haber un Responsable, que es la persona que deberá responder por la entrega de la tarea; un Accountable, quién delega las tareas que deben ser ejecutadas en pro de realizar la tarea asignada a la persona responsable; un Consulted, que es la persona que es buscada por los involucrados en el proyecto para comprender mejor un tema determinado; un Support, que es la persona quien deberá apoyar a la entrega de la tarea y finalmente un Informed, que son aquellos actualizados sobre el progreso del proyecto."+
    "\rFinalmente se ha elaborado cada uno de los procedimientos de cada microproceso, identificando cada paso, objetivo, involucrados y sus documentos de referencia, la descripción de las actividades que la comprenden, las entradas y salidas de los mismos, sus fuentes, registros, así como los registros utilizados en el procedimiento; teniendo en cuenta los plazos, y responsabilidades de los documentos emitidos.",
    c2:"ECOSHELL es una empresa dedicada al desarrollo de tecnología para crear productos elaborados a base de biomasa. La cual logra que los productos tengan un tiempo de biodegradación de 90 a 240 días sin dejar residuos tóxicos en el medio ambiente gracias a que los micro-organismos se alimentan de los productos logrando reintegrarlos a la naturaleza; la cual está integrada por cuatro áreas estratégicas, en primer lugar: la Dirección General, seguida de, la Dirección de Ventas, Dirección de Operaciones y Logística y Dirección de Finanzas, en las cuales se desglosan los macro y microprocesos que derivan de ellos."+
    "\r\r1. OBJETIVO DEL MANUAL"+
    "\rReducción y eliminación de actividades sin valor añadido a través de la reducción de etapas y tiempos de ciclo de las actividades, que permita la ampliación de las funciones y responsabilidades del personal."+
    "\rDeterminar métodos para asegurar que la operación y control de procesos sean eficaces través de su seguimiento, medición, análisis y mejora continua."+
    "\rGestionar y orientar a toda la organización basándose en la interrelación de procesos mediante vínculos causa - efecto y siguiendo una metodología para cumplir con la misión y objetivos institucionales establecidos contribuyendo así conjuntamente a ejercer un mayor control sobre los resultados de las actividades realizadas."+
    '\rIncrementar la eficiencia y eficacia, reducir costos, mejorar la calidad de los servicios, reducir los tiempos de su prestación, definiendo objetivos en términos de una mejor atención a los "clientes" internos y externos.'+
    "\r\r2. OBJETIVOS ESPECÍFICOS"+
    "\rMapeo y diagnóstico de procesos internos."+
    "\rReorientar y optimizar procesos."+
    "\rRedefinir responsables de cada procesos e involucrados."+
    "\rIdentificar procesos colaborativos.",
    c3:'Al identificar fallas en la operatividad, funcionalidad e indicadores que arrojaban diferentes áreas de oportunidad, se optó por trabajar con todos los equipos de trabajo, para que, en conjunto, se definieran y sobre todo se actualizara cada uno de los pasos para un correcto "deber Ser"',


  }
  org=[];
  raci=[];
  id_ht=0;
  fmt_ht_pdf2_(itm){
    localStorage.setItem("tpdf_ht","2")
    this.id_ht=itm.id_ht;
    this.fmt_ht_pdf(); 
  }
  fmt_ht_pdf(){    
    localStorage.setItem("t_ht","P");
    localStorage.setItem("id_ht",this.id_ht.toString());
    this.router.navigate([]).then(result => {  window.open('./#/fmtht', '_blank'); });     
  }
  bus_org(c){
    //console.log(c);
    //console.log(this.org)
    var aux=[]
    for(var i=0;i<this.org_aux.length;i++){ 
      var dep=this.org_aux[i].departamento==null?"":this.org_aux[i].departamento.toLowerCase()
      if(dep.toLowerCase().includes(c)){
        aux.push(this.org_aux[i])
      }      
    }
    this.org= aux;
  }
  org_aux=[];
  get_org(){
    this.authService.service("/api/get_org_role",{ id_cliente:localStorage.getItem("id_cliente")} )
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);  
           
            //console.log("org")   
            //console.log(res )   
            for(var i=0;i<res.length;i++){              
              if(res[i].organo!='A' ){
                //res[i].idx=0;                
                var x=""
                switch(res[i].organo){
                  case "D":x="1"+res[i].nivel;break;
                  case "P":x="2"+res[i].nivel;break;
                }
                res[i].orden=x;
                this.org.push(res[i])
                this.org_aux.push(res[i])
              }
            }   
            //console.log(this.org )    
            this.org.sort((a,b) => a.orden.localeCompare(b.orden))
            /*var idx=3
            for(var j=0;j<this.org.length;j++){  
              this.org[j].idx=idx+j;
            }*/

        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            
        });  
    


    }
    estructura={
      id:0,
      nombre:""
    }
    get_raci(){
      this.authService.service("/api/get_raci_p",{ id_cliente:localStorage.getItem("id_cliente")} )
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);  
            this.raci=res;
            //console.log(res)
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              
          });  
  
  
      }
      id_raci=0;
      fmt_raci(t){
        localStorage.setItem("t_raci",'P');
        localStorage.setItem("id_raci_pdf",t.id.toString()  );
        this.router.navigate([]).then(result => {  window.open('./#/fmt2', '_blank'); });          
      }
      ht=[];
      ls_ws(){
        let postData={
          id_cliente:localStorage.getItem("cliente")
         }
         this.authService.service("/api/get_ht_cli",postData)
           .then(
             data => {               
               var dat = JSON.stringify(data);
               var res = JSON.parse(dat); 
               console.log("ht:")
               console.log(res)
               this.ht=res;
             },
             error => {
                 var de= JSON.stringify(error);
                 var di = JSON.parse(de)
                 //this.loading=false;
                 swal.fire('¡API incorrecta..! get_ht_cli', '', 'error');
           });
      }
  bndmnugral=true;
    oculta_menu(){
      console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      console.log(this.bndmnugral);
    }
    area=[
          {id:1,idx:4,nombre:"area 1"},
          {id:2,idx:5,nombre:"area 2"}
        ]
    cap=[
          {id:1,id_area:1,idx:4,nombre:"subarea 1"},
          {id:2,id_area:1,idx:5,nombre:"subarea 2"}
        ]
        raci_name="";
        ws_name="";
        codigo="";
        sugerido=""
        nom_cliente="";
        nom_dep="";
        codigo_sufijo="";
        fn_sugerido(){
          this.codigo_sufijo=this.sugerido;
        }
        gda_sufijocliente(){
          let postData={
            id:localStorage.getItem("cliente"),
            sufijo:this.codigo_sufijo
           }
           if(this.codigo_sufijo.length==0)return;
           this.authService.service("/api/gda_sufijo_cli",postData)
             .then(
               data => {
                localStorage.setItem("sufijo_cliente",this.codigo_sufijo)
                 this.sufijo_cliente=this.codigo_sufijo;
                 swal.fire('¡ok', '', 'success');
               },
               error => {
                   var de= JSON.stringify(error);
                   var di = JSON.parse(de)
                   //this.loading=false;
                   swal.fire('¡API incorrecta..! get_ht_cli', '', 'error');
             });    this.clo_pernva.nativeElement.click()
        }
        v_c_(){
          this.codigo_sufijo=this.sufijo_cliente;
          this.nom_cliente=localStorage.getItem("nom_cliente")
          this.nom_cliente=this.nom_cliente.toLocaleUpperCase().replace("  "," ")          
          var c1=this.nom_cliente.split(" ")
          if(c1.length==1){
            this.sugerido=this.nom_cliente.substring(0,3)
          }else{
            this.sugerido=c1[0].substring(0,1)+c1[1].substring(0,2)
          }
        }
        gda_sufijo_departamento(){
          if(this.codigo_sufijo.length==0)return;
          let postData={
            id:this.id_role,
            sufijo:this.codigo_sufijo,
            departamento:this.departamento
           }
           console.log(postData)
           this.authService.service("/api/gda_sufijo_org",postData)
             .then(
               data => {
                  //localStorage.setItem("sufijo_cliente",this.codigo_sufijo)
                  //this.sufijo_cliente=this.codigo_sufijo;
                  //console.log(this.id_role);
                  
                 for(var i=0;i<this.org_.length;i++){
                  if(this.org_[i].id_role==this.id_role){
                    this.org_[i].sufijo=this.codigo_sufijo;
                    this.org_[i].departamento=this.departamento;
                  }
                 }
                 for(var i=0;i<this.org_aux.length;i++){
                  if(this.org_aux[i].id_role==this.id_role){
                    this.org_aux[i].sufijo=this.codigo_sufijo;
                    this.org_aux[i].departamento=this.departamento;
                  }
                 }
                 this.clo_d.nativeElement.click()
                 swal.fire('¡ok', '', 'success');
               },
               error => {
                   var de= JSON.stringify(error);
                   var di = JSON.parse(de)
                   //this.loading=false;
                   swal.fire('¡API incorrecta..! get_ht_cli', '', 'error');
             });    
        }
        id_role=0;
        v_d_(itm){
           console.log(itm)
          this.role=itm.role_card;
          this.departamento=itm.departamento;
          this.codigo_sufijo=itm.sufijo;
          this.id_role=itm.id_role;
         
          var c=itm.role_card.toLocaleUpperCase().replace("  "," ")
          var c=c.replace(" DEL","")
          var c=c.replace(" DE","")          
          var c1=c.split(" ")
          if(c1.length==1){
            this.sugerido=this.nom_cliente.substring(0,3)
          }if(c1.length>2){
            this.sugerido=c1[0].substring(0,1)+c1[1].substring(0,1)+c1[2].substring(0,1)
          }else{
            this.sugerido=c1[0].substring(0,1)+c1[1].substring(0,2)
          }
         
        }
        gda_sufijo_raci(){
          if(this.codigo_sufijo.length==0)return;
          let postData={
            id:this.id_raci,
            sufijo:this.codigo_sufijo
           }
           if(this.codigo_sufijo.length==0)return;
           this.authService.service("/api/gda_sufijo_raci",postData)
             .then(
               data => {
                //localStorage.setItem("sufijo_cliente",this.codigo_sufijo)
                 //this.sufijo_cliente=this.codigo_sufijo;
                 console.log(this.id_role);
                 console.log(this.org);
                 for(var i=0;i<this.raci.length;i++){
                  if(this.raci[i].id==this.id_raci){
                    this.raci[i].sufijo=this.codigo_sufijo;
                    this.raci[i].departamento=this.departamento;
                  }
                 }
                 this.clo_r.nativeElement.click()
                 swal.fire('¡ok', '', 'success');
               },
               error => {
                   var de= JSON.stringify(error);
                   var di = JSON.parse(de)
                   //this.loading=false;
                   swal.fire('¡API incorrecta..! get_ht_cli', '', 'error');
             });   
        }
        ht_name=""
        role=""
        departamento=""
        gda_sufijo_ht(){
          if(this.codigo_sufijo.length==0)return;
          let postData={
            id:this.id_ht,
            sufijo:this.codigo_sufijo 
           }
            //console.log(postData)
           this.authService.service("/api/gda_sufijo_ht",postData)
             .then(
               data => {
                //localStorage.setItem("sufijo_cliente",this.codigo_sufijo)
                 //this.sufijo_cliente=this.codigo_sufijo;
                 //console.log(this.id_role);
                 //console.log(this.org);
                 for(var i=0;i<this.ht.length;i++){
                  if(this.ht[i].id_ht==this.id_ht){
                    this.ht[i].codigo=this.codigo_sufijo;
                  }
                 }
                 this.clo_ht.nativeElement.click()
                 swal.fire('¡ok', '', 'success');
               },
               error => {
                   var de= JSON.stringify(error);
                   var di = JSON.parse(de)
                   //this.loading=false;
                   swal.fire('¡API incorrecta..! get_ht_cli', '', 'error');
             });    
        }
        nom_ht="";
        v_ws_(itm){
          //console.log(itm)
          this.codigo_sufijo=itm.codigo;
          this.id_ht=itm.id_ht;   
          this.nom_ht=itm.ht
          var c=itm.ht.toLocaleUpperCase().replace("  "," ") 
          var c=c.replace(" DEL","")
          var c=c.replace(" DE","")   
          var c=c.replace(" Y","")   
          var c1=c.split(" ")
          if(c1.length==1){
            try {
              this.sugerido=c1[0].substring(0,3)  
            } catch (error) {
            }
          }if(c1.length>2){
            this.sugerido=c1[0].substring(0,1)+c1[1].substring(0,1)+c1[2].substring(0,1)
          }else{
            this.sugerido=c1[0].substring(0,1)+c1[1].substring(0,2)
          }
          this.codigo=this.sufijo_cliente+"-"
          this.ws_name=itm.ht

        }
        nom_raci=""
        doc_=[]
        
        del_doc(itm){
          if(confirm(" Desea eliminar el registro?")==false)return;
          let postData={
            id:itm.id
           }
            console.log(postData)
           this.authService.service("/api/del_racidoc",postData)
             .then(
               data => {
                var dat = JSON.stringify(data);
                var res = JSON.parse(dat); 
                var aux=[]
                for(var i=0;i<this.doc_.length;i++){
                  if(this.doc_[i].id!=itm.id){
                    aux.push(this.doc_[i])
                  }
                }this.doc_=aux;
                for(var i=0;i<this.raci.length;i++){
                  if(this.raci[i].id==this.id_raci){
                    if(itm.tipo==0){
                      
                      this.raci[i].doc_externo=this.raci[i].doc_externo.replace(itm.nombre,"")
                    }else if(itm.tipo==1){
                      this.raci[i].doc_interno=this.raci[i].doc_interno.replace(itm.nombre,"")
                    }
                  }
                }

                console.log(res)
                // swal.fire('¡ok', '', 'success');
               },
               error => {
                   var de= JSON.stringify(error);
                   var di = JSON.parse(de)
                   //this.loading=false;
                   swal.fire('¡API incorrecta..! get_ht_cli', '', 'error');
             });    

        }
        t_doc=0
        doc_n=""
        gda_doc(){
          if(this.doc_n=="")return;
          let postData={
            raci_id:this.id_raci,
            nombre:this.doc_n,
            tipo:this.t_doc
           }
            console.log(postData)
           this.authService.service("/api/gda_racidoc",postData)
             .then(
               data => {
                var dat = JSON.stringify(data);
                var res = JSON.parse(dat); 
                this.doc_.push({
                  id:res.insertId,
                  id_raci:this.id_raci,
                  tipo:this.t_doc,
                  nombre:this.doc_n,
                  estatus:'A'
                })

                for(var i=0;i<this.raci.length;i++){
                  if(this.raci[i].id==this.id_raci){
                    if(this.t_doc==0){
                      
                      this.raci[i].doc_externo=this.raci[i].doc_externo+","+this.doc_n
                    }else if(this.t_doc==1){
                      this.raci[i].doc_interno=this.raci[i].doc_interno+","+this.doc_n
                    }
                  }
                }
                //this.doc_=res;
                console.log(res)
                // swal.fire('¡ok', '', 'success');
               },
               error => {
                   var de= JSON.stringify(error);
                   var di = JSON.parse(de)
                   //this.loading=false;
                   swal.fire('¡API incorrecta..! get_ht_cli', '', 'error');
             });  
        }
        v_doc_(itm,t){
          this.id_raci=itm.id
          this.t_doc=t
          let postData={
            id_raci:itm.id
           }
            console.log(postData)
           this.authService.service("/api/get_racidoc",postData)
             .then(
               data => {
                var dat = JSON.stringify(data);
                var res = JSON.parse(dat); 
                this.doc_=res;
                console.log(res)
                // swal.fire('¡ok', '', 'success');
               },
               error => {
                   var de= JSON.stringify(error);
                   var di = JSON.parse(de)
                   //this.loading=false;
                   swal.fire('¡API incorrecta..! get_ht_cli', '', 'error');
             });    

        }
        v_r_(itm){
          this.codigo_sufijo=itm.sufijo;
          //console.log(itm)
          this.id_raci=itm.id; 
          this.nom_raci=itm.descipcion
          var c=itm.descipcion.toLocaleUpperCase().replace("  "," ")
          //console.log(itm.descipcion)
          var c=c.replace(" DEL","")
          var c=c.replace(" DE","")   
          var c=c.replace(" Y","")         
          var c1=c.split(" ")
          //console.log(c1)
          if(c1.length==1){
            try {
              this.sugerido=c1[0].substring(0,3)  
            } catch (error) {
            }
          }if(c1.length>2){
            this.sugerido=c1[0].substring(0,1)+c1[1].substring(0,1)+c1[2].substring(0,1)
          }else{
            this.sugerido=c1[0].substring(0,1)+c1[1].substring(0,2)
          }
          this.codigo=this.sufijo_cliente+"-"
          this.raci_name=itm.descipcion
          //console.log(itm);
        }
    fn_ftm_(id){   
      //console.log(id)
      localStorage.setItem("_id_org",id.id_role)
      //localStorage.setItem("documento",JSON.stringify(this.documento))
      localStorage.setItem("_org",JSON.stringify(this.org_))
      localStorage.setItem("_raci",JSON.stringify(this.raci))
      localStorage.setItem("_ht",JSON.stringify(this.ht))
      //return ;
      this.router.navigate([]).then(result => {  window.open('./#/fmtdfinal', '_blank'); });   
    }     
    fn_ftm(){
      //localStorage.setItem("documento",JSON.stringify(this.documento))
      localStorage.setItem("_org",JSON.stringify(this.org_))
      localStorage.setItem("_raci",JSON.stringify(this.raci))
      localStorage.setItem("_ht",JSON.stringify(this.ht))
      this.router.navigate([]).then(result => {  window.open('./#/fmtdfinal', '_blank'); });         
    }
}
